import type { ReactElement } from 'react';
import React, { useState, useEffect } from 'react';
import { DollarSignMd } from '@construct-kit/core';
import type { AllChannelObjects } from '../../../../shared/model/tsTypes';
import { ForLease, ForSale } from '../../../../shared/model/constants/channels';
import {
  BUY_PRICE_RANGES,
  SOLD_PRICE_RANGES,
  FORLEASE_PRICE_RANGES,
} from '../constants/filtersOptions';
import SliderInput from './SliderInput';
import { FilterWrapper } from './FilterWrapper';
import { Leasing, Selling } from '../../../../shared/model/constants/customerChannels';

export type PriceFilterProps = {
  selectedChannel: AllChannelObjects;
  hideHeading?: boolean;
  showDivider?: boolean;
  searchQueryPriceRange: Array<number>;
  onChange: (newPriceRange: number[]) => void;
};

const getPriceSteps = (selectedChannel: AllChannelObjects): number[] => {
  switch (selectedChannel.id) {
    case ForSale.id:
    case Selling.id:
      return BUY_PRICE_RANGES;
    case ForLease.id:
    case Leasing.id:
      return FORLEASE_PRICE_RANGES;
    default:
      return SOLD_PRICE_RANGES;
  }
};

export const PriceFilter = ({
  selectedChannel,
  hideHeading,
  searchQueryPriceRange,
  showDivider,
  onChange,
}: PriceFilterProps): ReactElement => {
  const [priceRange, setPriceRange] = useState<number[]>(getPriceSteps(selectedChannel));

  const isLease = selectedChannel.id === ForLease.id || selectedChannel.id === Leasing.id;

  useEffect(() => {
    setPriceRange(getPriceSteps(selectedChannel));
  }, [selectedChannel]);

  return (
    <FilterWrapper title="Price" hideHeading={hideHeading} showDivider={showDivider}>
      <SliderInput
        icon={<DollarSignMd />}
        filterRanges={priceRange}
        textInputLabel={isLease ? 'price (p.a)' : 'price'}
        searchQueryRange={searchQueryPriceRange}
        onChange={onChange}
      />
    </FilterWrapper>
  );
};
